// HeraldWorkbench — per-agent wrapper over <CompositionWorkbench> for
// HERALD, the onboarding-pack composer. Surfaces the canonical pack
// documents (terms of business, fee schedule, disclosures, fact-find
// prompt) via the `renderSections` slot.

import CompositionWorkbench from '.';
import { compositionAgentConfig } from './composition-agent-config';
import type { BaseDraft } from '@/data/types';

export interface HeraldDraft extends BaseDraft {
    pack_documents?: Array<{ kind: string; title: string }>;
}

interface HeraldWorkbenchProps {
    draft: HeraldDraft;
    readOnly?: boolean;
    onApproved?: (draft: HeraldDraft) => void;
    onRejected?: (draft: HeraldDraft) => void;
    onRevisionRequested?: (draft: HeraldDraft) => void;
}

export default function HeraldWorkbench({
    draft,
    readOnly,
    onApproved,
    onRejected,
    onRevisionRequested,
}: HeraldWorkbenchProps) {
    return (
        <CompositionWorkbench<HeraldDraft>
            agentName="HERALD"
            draft={draft}
            table={compositionAgentConfig.HERALD.table}
            actions={compositionAgentConfig.HERALD.actions}
            readOnly={readOnly}
            renderSections={(d) =>
                d.pack_documents && d.pack_documents.length > 0 ? (
                    <div
                        data-testid="herald-pack-documents"
                        className="rounded-md border border-[rgb(var(--color-divider))] bg-[rgb(var(--color-surface-secondary)/0.4)] p-3"
                    >
                        <div className="text-card-title text-[rgb(var(--color-text-primary))] mb-2">
                            Pack documents
                        </div>
                        <ul className="flex flex-col gap-1">
                            {d.pack_documents.map((doc, i) => (
                                <li
                                    key={i}
                                    className="text-annotation text-[rgb(var(--color-text-secondary))]"
                                >
                                    <span className="font-mono text-[rgb(var(--color-text-primary))]">
                                        [{doc.kind}]
                                    </span>{' '}
                                    {doc.title}
                                </li>
                            ))}
                        </ul>
                    </div>
                ) : null
            }
            onApproved={onApproved}
            onRejected={onRejected}
            onRevisionRequested={onRevisionRequested}
        />
    );
}
